export const ROLE = 'ROLE';
export const EXTENSION = 'EXTENSION';
